import React from 'react';
import { useIntl } from 'react-intl';
import { useConfirmAlert } from '@/contexts/ConfirmAlertContext';

const ConfirmAlert = () => {
  const intl = useIntl();
  const { isOpen, message, onOk, onCancel } = useConfirmAlert();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-[3px] shadow-lg w-fit max-w-[90vw] md:max-w-[600px] overflow-hidden transform transition-all scale-100 animate-in zoom-in duration-200">
        <div className="p-6 pb-2">
          <p className="text-[21px] font-medium text-[#393939] font-['Open_Sans'] leading-[1.2] text-left">
            {message}
          </p>
        </div>
        <div className="px-6 pb-4 flex justify-end gap-2">
          <button
            type="button"
            className="inline-flex items-center justify-center min-w-[64px] h-9 px-4 bg-[#859905] hover:opacity-80 text-white rounded-[3px] font-['Open_Sans'] transition-all text-sm font-bold"
            onClick={onOk}
            tabIndex={2}
          >
            {intl.formatMessage({ id: 'OK' })}
          </button>
          <button
            type="button"
            className="inline-flex items-center justify-center min-w-[64px] h-9 px-4 bg-[#c1c1c1] hover:opacity-80 text-white rounded-[3px] font-['Open_Sans'] transition-all text-sm font-bold"
            onClick={onCancel}
            tabIndex={1}
            autoFocus
          >
            {intl.formatMessage({ id: 'CANCEL' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAlert;
